var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import _ from 'lodash';
import { notesStateService } from 'ziphy-web-shared/basic/api';
import { isEmptyCode, isUnspecifiedCode, } from 'ziphy-web-shared/basic/entities/notes/resources';
class BlockStore {
    constructor({ parent, ref, sectionId, type }) {
        this.parent = parent;
        this.ref = ref;
        this.sectionId = sectionId;
        this.type = type;
        makeObservable(this, {
            encounterId: computed,
            // @ts-ignore
            _bd: computed,
            source: computed,
            blocked: computed,
            touched: computed,
            section: computed,
            SET_ERROR: action,
            save: action,
            move: action,
            delete: action,
        });
    }
    // Computed
    get _bd() {
        return (this.parent._blocksData.get(this.ref) || {});
    }
    get id() {
        return this._bd.id;
    }
    get encounterId() {
        return this.parent.encounter.id;
    }
    get source() {
        return this._bd.source;
    }
    get blocked() {
        return Boolean(this._bd.blocked);
    }
    get touched() {
        return Boolean(this._bd.touched);
    }
    get section() {
        return this.parent.getSection(this.sectionId);
    }
    // Mutations
    SET_ERROR(error, ref, action) {
        this.parent.SET_ERROR(error, { sectionId: this.sectionId, blockRef: this.ref, ref }, action);
    }
    // Actions
    save(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield notesStateService.saveBlock(this.getParams(params));
            if (!response.error) {
                runInAction(() => this.parent.UPDATE_STATE(response.prepared, { initialRef: this.ref }));
            }
            return response;
        });
    }
    move(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield notesStateService.moveBlock(this.getParams(Object.assign({ sectionId: this.sectionId }, params)));
            if (!response.error) {
                runInAction(() => this.parent.UPDATE_STATE(response.prepared, { initialRef: this.ref }));
            }
            return response;
        });
    }
    delete(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield notesStateService.deleteBlock(this.getParams(Object.assign({ sectionId: this.sectionId }, params)));
            if (!response.error) {
                runInAction(() => this.parent.UPDATE_STATE(response.prepared, { initialRef: this.ref }));
            }
            return response;
        });
    }
    getParams(params = {}) {
        return Object.assign({ encounterId: this.parent.encounter.id, blockRef: this.ref }, params);
    }
}
export class TextBlockStore extends BlockStore {
    constructor(props) {
        super(props);
        makeObservable(this, {
            title: computed,
            text: computed,
            data: computed,
            isEmptyTextBlock: computed,
            isResource: computed,
            isCondition: computed,
            isMayHaveChildren: computed,
            errors: computed,
            validate: action,
        });
    }
    get title() {
        var _a;
        return (_a = this._bd.title) !== null && _a !== void 0 ? _a : null;
    }
    get text() {
        var _a;
        return (_a = this._bd.text) !== null && _a !== void 0 ? _a : '';
    }
    get data() {
        return this._bd.data;
    }
    get isEmptyTextBlock() {
        return this._bd.ref.includes('empty_text');
    }
    get isResource() {
        return false;
    }
    get isCondition() {
        return false;
    }
    get isMayHaveChildren() {
        return false;
    }
    get errors() {
        return _.pick(this.parent.errors, ['empty_placeholder']);
        // return _.pick(this.parent.errors, ['empty_placeholder', 'unspecified_code', 'empty_code'])
    }
    validate() {
        Object.values(this.data).forEach((x) => {
            const isEmpty = !Boolean(x.value) || (Array.isArray(x.value) && x.value.length === 0);
            this.SET_ERROR('empty_placeholder', x.id, isEmpty);
            //
            // if (!isEmpty && x.type === 'resource') {
            //   const refs = Array.isArray(x.fhirRef) ? x.fhirRef : [x.fhirRef]
            //
            //   refs.forEach((ref) => {
            //     const block = Array.from(this.parent._blocks.values()).find((x) => x.data[ref])
            //     if (block instanceof ResourceBlockStore) {
            //       const resource = block.data[ref]
            //       if (resource.resourceType === 'Condition') {
            //         this.SET_ERROR('unspecified_code', x.id, isUnspecifiedCode(resource?.code))
            //       }
            //       if (
            //         resource.resourceType === 'MedicationStatement' ||
            //         resource.resourceType === 'MedicationRequest'
            //       ) {
            //         this.SET_ERROR('empty_code', x.id, isEmptyCode(resource?.medication?.code))
            //       } else {
            //         console.log(x.id, resource)
            //         this.SET_ERROR('empty_code', x.id, isEmptyCode(resource.code))
            //       }
            //     }
            //   })
            // }
        });
    }
}
export class ResourceBlockStore extends BlockStore {
    constructor(props) {
        super(props);
        makeObservable(this, {
            title: computed,
            multi: computed,
            data: computed,
            resourceContext: computed,
            resourceType: computed,
            isEmptyTextBlock: computed,
            isResource: computed,
            isCondition: computed,
            isMayHaveChildren: computed,
            errors: computed,
            validate: action,
        });
    }
    get title() {
        var _a;
        return (_a = this._bd.title) !== null && _a !== void 0 ? _a : null;
    }
    get multi() {
        var _a;
        return (_a = this._bd.multi) !== null && _a !== void 0 ? _a : false;
    }
    get data() {
        return this._bd.data;
    }
    get resourceContext() {
        return {
            resourceType: this._bd.resourceType,
            element: this._bd.element,
            searchPreference: this._bd.searchPreference,
        };
    }
    get resourceType() {
        return this.resourceContext.resourceType;
    }
    get isEmptyTextBlock() {
        return false;
    }
    get isResource() {
        return true;
    }
    get isCondition() {
        return this.resourceType === 'Condition';
    }
    get isMayHaveChildren() {
        var _a, _b;
        if (this.section.id === 'assessment') {
            return this.isCondition;
        }
        if (this.section.id === 'billing') {
            const childrenCount = (_b = (_a = this.section.allFlattenBlocksMap.get(this.ref)) === null || _a === void 0 ? void 0 : _a.blocks) === null || _b === void 0 ? void 0 : _b.length;
            return (this.resourceType === 'Procedure' &&
                childrenCount < this.section.practiceSettings.billingReasonLimit);
        }
        return false;
    }
    get errors() {
        return _.pick(this.parent.errors, ['unspecified_code', 'empty_code']);
    }
    validate() {
        Object.values(this.data).forEach((x) => {
            var _a;
            if (this.resourceType === 'Condition' && this.parent.practiceSettings.specifiedConditions) {
                this.SET_ERROR('unspecified_code', x.id, isUnspecifiedCode(x.code));
            }
            if (this.resourceType === 'MedicationStatement' ||
                this.resourceType === 'MedicationRequest') {
                this.SET_ERROR('empty_code', x.id, isEmptyCode((_a = x === null || x === void 0 ? void 0 : x.medication) === null || _a === void 0 ? void 0 : _a.code));
            }
            else if ('code' in x) {
                this.SET_ERROR('empty_code', x.id, isEmptyCode(x.code));
            }
        });
    }
}
export class TemplateBlockStore extends BlockStore {
    constructor(props) {
        super(props);
        this.isEditing = false;
        this.isEditing = !this.parent.isPlain && this.isEmpty;
        makeObservable(this, {
            isEditing: observable,
            title: computed,
            templateId: computed,
            data: computed,
            isEmptyTextBlock: computed,
            isResource: computed,
            isCondition: computed,
            isMayHaveChildren: computed,
            isEmpty: computed,
            errors: computed,
            SET_EDITING: action,
            validate: action,
        });
    }
    get title() {
        var _a;
        return (_a = this._bd.title) !== null && _a !== void 0 ? _a : null;
    }
    get templateId() {
        return this._bd.templateId;
    }
    get data() {
        return this._bd.data;
    }
    get isEmptyTextBlock() {
        return false;
    }
    get isResource() {
        return false;
    }
    get isCondition() {
        return false;
    }
    get isMayHaveChildren() {
        return false;
    }
    get isEmpty() {
        return _.isEmpty(this.data.payload);
    }
    get isLocked() {
        return this.parent.isLocked;
    }
    get errors() {
        return _.pick(this.parent.errors, ['empty_template']);
    }
    // Mutations
    SET_EDITING(value) {
        runInAction(() => (this.isEditing = value));
    }
    // Actions
    save(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield notesStateService.saveTemplate(this.getParams(params));
            if (!response.error) {
                runInAction(() => this.parent.UPDATE_STATE(response.prepared, { initialRef: this.ref }));
            }
            return response;
        });
    }
    saveText(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield notesStateService.saveTemplateText(this.getParams(params));
            if (!response.error)
                runInAction(() => this.parent.UPDATE_BLOCK_DATA(this.ref, { data: { text: params.text } }));
            return response;
        });
    }
    validate() {
        this.SET_ERROR('empty_template', this.ref, this.isEmpty || this.isEditing);
    }
}
export class BlockFactory {
    static create(parent, sectionId, ref) {
        const block = parent._blocksData.get(ref);
        if (!block) {
            throw new Error(`Block with ref ${ref} not found`);
        }
        const type = block.type;
        switch (type) {
            case 'text':
                return new TextBlockStore({ parent, ref, sectionId, type });
            case 'resource':
                return new ResourceBlockStore({ parent, ref, sectionId, type });
            case 'template':
                return new TemplateBlockStore({ parent, ref, sectionId, type });
            default:
                throw new Error(`Unknown block type: ${type}, ${sectionId}, ${ref}`);
        }
    }
    static createEmptyText(parent, sectionId, ref) {
        const block = parent._blocksData.get(ref);
        if (!block) {
            throw new Error(`Block with ref ${ref} not found`);
        }
        return new TextBlockStore({ parent, ref, sectionId, type: 'text' });
    }
}
